<div [class]="valueStyle">
  @for (attachment of (bitstreams$ | async); track attachment) {
    <div class="mb-2">
      <ds-truncatable [id]="attachment.id">
        <ds-file-download-link [bitstream]="attachment" [enableRequestACopy]="true" [item]="item" [showIcon]="true">
          @if (fileName(attachment)) {
            <span data-test="title">@if (getType(attachment)) {
              <span data-test="type" class="fw-bold">{{getType(attachment) | titlecase}}: </span>
            }{{fileName(attachment)}} ({{getSize(attachment) | dsFileSize}})</span>
          }
        </ds-file-download-link>
        <ds-truncatable-part [id]="attachment.id" [minLines]="1">
          @if (getDescription(attachment)) {
            <span data-test="description">{{getDescription(attachment)}}</span>
          }
        </ds-truncatable-part>
      </ds-truncatable>
    </div>
  }
  @if (canViewMore) {
    <div class="my-2">
      <i class="fas fa-chevron-down"></i>&nbsp;
      <a href="javascript:void(0);" data-test="view-more" (click)="viewMore()">{{'cris-layout.attachment.viewMore' | translate}}</a>
    </div>
  }
</div>
